import { Injectable } from '@angular/core';
import { Firebase } from '@ionic-native/firebase';
import { Platform } from 'ionic-angular';
import * as firebase from 'firebase';
import { WalletService } from '../services/wallet.service';
/*
  Generated class for the FcmProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class FcmService {
  constructor(
    public firebaseNative: Firebase,
    private platform: Platform,
    public walletService: WalletService
  ) {
    console.log('Hello FcmProvider Provider');
  }

  // Get permission from the user
  async getToken(user) {
    let token;

    if (this.platform.is('android')) {
      token = await this.firebaseNative.getToken();
    }

    if (this.platform.is('ios')) {
      token = await this.firebaseNative.getToken();
      await this.firebaseNative.grantPermission();
    }

    return this.saveTokenToFirestore(token, user);
  }

  // Save the token to firestore
  private saveTokenToFirestore(token, user) {
    if (!token) return;

    return firebase
      .database()
      .ref('prod_fans_devices/' + user.uid)
      .set({
        token: token
      });
  }

  // Listen to incoming FCM messages
  listenToNotifications() {
    return this.firebaseNative.onNotificationOpen();
  }
}



// WEBPACK FOOTER //
// ./src/services/fcm.service.ts